"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("crm_data/actions/ActionTypes"));

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _default = {
  update: function update(objectType, searchQuery, results) {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.default.ES_DATA_UPDATED, {
      objectType: objectType,
      searchQuery: searchQuery,
      results: results
    });
  },
  moveResult: function moveResult(objectType, fromSearchQuery, toSearchQuery, fromViewId, toViewId, id, toIndex) {
    id = parseInt(id, 10);
    return (0, _Dispatch.dispatchQueue)(_ActionTypes.default.ES_RESULT_MOVED, {
      objectType: objectType,
      fromSearchQuery: fromSearchQuery,
      toSearchQuery: toSearchQuery,
      fromViewId: fromViewId,
      toViewId: toViewId,
      id: id,
      toIndex: toIndex
    }).done();
  }
};
exports.default = _default;
module.exports = exports.default;